import { render, staticRenderFns } from "./repairview.vue?vue&type=template&id=a8fdc312&scoped=true&"
import script from "./repairview.vue?vue&type=script&lang=js&"
export * from "./repairview.vue?vue&type=script&lang=js&"
import style0 from "./repairview.vue?vue&type=style&index=0&id=a8fdc312&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8fdc312",
  null
  
)

export default component.exports